import React, {useEffect} from 'react';
import {getCurrentPosition, queryParser} from '../../common/helper';
import {useDispatch, useSelector} from 'react-redux';
import {setEventsData, setOfferType, setPaymentStatus, setPseudoFlow} from './onboardingSlice';
import {
    selectToken,
    setToken,
    setBtToken,
    setUserUuid,
    setStripeData,
    setAlternativeStripeData,
    getPaymentSettings,
} from '../auth/authSlice';
import {setBrowserCoords} from '../dashboard/dashboardSlice';
import Cookies from 'js-cookie';


const OnboardingAuth = ({history}) => {
    const dispatch = useDispatch();
    const token = useSelector(selectToken);


    useEffect(() => {
        const {token, btToken, payment, offerType, data} = queryParser(history.location.search);

        const encodedData = data ? JSON.parse(atob(data)) : { stripeSettings: null };
        const { stripeSettings, ...eventsData} = encodedData;
        const userUuid = eventsData?.['user_data']?.uuid;

        dispatch(setToken(token));
        if (btToken && offerType !== 'intro') {
            dispatch(setBtToken(btToken));
        }
        if (stripeSettings) {
            dispatch(setStripeData(stripeSettings));
            stripeSettings.alternativeSettings && dispatch(setAlternativeStripeData(stripeSettings.alternativeSettings));
        } else {
            dispatch(getPaymentSettings(token));
        }
        dispatch(setPaymentStatus(!!payment));
        dispatch(setEventsData(eventsData));

        dispatch(setUserUuid(userUuid || null));
        Cookies.set('userUuid',userUuid, {expires: 365});

        dispatch(setPseudoFlow(true));
        offerType && dispatch(setOfferType(offerType));
    }, [history]);

    useEffect(() => {
        getCurrentPosition(dispatch, setBrowserCoords);
    }, []);

    useEffect(() => {
        token && history.push('/signing-in');
    }, [token]);


    return (
        <>
        </>
    );
};

export default OnboardingAuth;

